export function maybeCompleteOAuthSession() {
  // Supabase handles the browser redirect directly on web.
}

export function openOAuthSessionAsync(_startUrl: string, _returnUrl: string) {
  throw new Error('openOAuthSessionAsync is only available on native.');
}
